import {ReferencePoint, RegionConfig} from '../../../types'

const CN14: ReferencePoint = {
  geo: {latitude: 32.51667, longitude: 107.88333},
  svg: {x: 216, y: 171}
}

const BD11: ReferencePoint = {
  geo: {latitude: 22.27963, longitude: 91.79513},
  svg: {x: 127, y: 228}
}

const I004: ReferencePoint = {
  geo: {latitude: 13.308887, longitude: 76.9424},
  svg: {x: 54, y: 300}
}

const BN11: ReferencePoint = {
  geo: {latitude: 5.0129104, longitude: 115.06462},
  svg: {x: 273, y: 345}
}

const ID19: ReferencePoint = {
  geo: {latitude: -6.4798, longitude: 106.8961},
  svg: {x: 230, y: 417}
}

const ID27: ReferencePoint = {
  geo: {latitude: -6.4798, longitude: 106.8961},
  svg: {x: 230, y: 417}
}

const AU4109: ReferencePoint = {
  geo: {latitude: -27.413247, longitude: 153.1405086},
  svg: {x: 495, y: 536}
}

const AU4113: ReferencePoint = {
  geo: {latitude: -41.33179366, longitude: 146.4172826},
  svg: {x: 400, y: 590}
}

const I001: ReferencePoint = {
  geo: {latitude: 23.989944, longitude: 79.39384},
  svg: {x: 70, y: 245}
}

const I003: ReferencePoint = {
  geo: {latitude: 25.496967, longitude: 78.70958},
  svg: {x: 65, y: 230}
}

const S100: ReferencePoint = {
  geo: {latitude: 14.672439, longitude: 100.804726},
  svg: {x: 196, y: 295}
}

export const APAC_CONFIG: RegionConfig = {
  triangles: [
    {
      name: 'Narsingarh-Jhansi-Ammasandra',
      points: [I001, I003, I004]
    },
    {
      name: 'Pukrang-Citeureup-Jingyang',
      points: [S100, ID19, CN14]
    },
    {
      name: 'Citeureup-Jhansi-Jingyang',
      points: [ID27, I003, CN14]
    },
    {
      name: 'Jingyang-Chittagong-Brisbane',
      points: [CN14, BD11, AU4109]
    },
    {
      name: 'Chittagong-Ammasandra-Serasa',
      points: [BD11, I004, BN11]
    },
    {
      name: 'Ammasandra-Serasa-Brisbane',
      points: [I004, BN11, AU4109]
    },
    {
      name: 'Jingyang-Chittagong-Ammasandra',
      points: [CN14, BD11, I004]
    },
    {
      name: 'Railton-Jingyang-Narsingarh',
      points: [AU4113, CN14, I001]
    },
    {
      name: 'Railton-Jingyang-Jhansi',
      points: [AU4113, CN14, I003]
    }
  ]
}
